import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  content: css`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,
  background: css`
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
  `,
  foreground: css`
    z-index: 1;
    display: flex;
    width: 100%;
    height: 100%;
  `,
  rightPanel: css`
    position: relative;
    display: flex;
    overflow: hidden;
  `,
  rightPanelContent: css`
    display: flex;
    width: 100%;
    height: 100%;
  `,
  wrapper: css`
    display: flex;
    overflow: hidden;
    width: 100%;
  `,
  loaderContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
